<ul>
  <li *ngFor="let item of AD_providers">
      <a [href]="item.url">
        <div fxLayoutAlign="center center" fxLayout="column">
          <span class="social-icon-holder circle border" *ngIf="item.logo_url === undefined" [title]="item.display_name ? item.display_name : item.provider_name | titlecase">
            <span class="social-icon" [ngClass]="'cidaas-icon-provider'"></span>
          </span>
          <span class="social-icon-holder" *ngIf="item.logo_url != undefined" [title]="item.display_name ? item.display_name : item.provider_name | titlecase">
            <img [src]="item.logo_url" style="width:100%"/>
          </span>
          <label class="ad-login-item">{{item.display_name ? item.display_name : item.provider_name | titlecase}}</label>
        </div>
      </a>
  </li>
</ul>
